export default function CloseIcon({
  strokeColor = 'currentColor',
  strokeWidth = 3,
  width = 32,
  height = 32
}: {
  strokeColor?: string;
  strokeWidth?: number;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={strokeWidth}
      stroke={strokeColor}
      className='cursor-pointer'
      width={width}
      height={height}
    >
      <path strokeLinecap='round' strokeLinejoin='round' d='M6 18L18 6M6 6l12 12' />
    </svg>
  );
}
